import React from 'react';
import './About.css';

const About = () => {
    return (
        <div className="about-page">
            <section className="about-hero" data-aos="fade-up">
                <h1>About <span>THEIC</span></h1>
                <p>Empowering the next generation of Semiconductor Experts.</p>
            </section>

            <section className="about-details">
                <div className="detail-card glass" data-aos="fade-right">
                    <h2>Our Mission</h2>
                    <p>To provide high-quality, industry-standard training in VLSI design and verification, making our students global leaders in the semiconductor domain.</p>
                </div>
                <div className="detail-card glass" data-aos="fade-left">
                    <h2>Why THEIC?</h2>
                    <p>Our training is 100% project-oriented. We don't just teach theory; we prepare you for the real challenges of silicon design.</p>
                </div>
            </section>
        </div>
    );
};

export default About;